import React, { FunctionComponent } from 'react';


export interface IResultnumberProps {
    isDesktop: boolean;
    resultPerPage: number;
    numberOfResults: number;
    currentPageNumber: number;
    searchQuery?: string;
}



export const Resultnumber: FunctionComponent<IResultnumberProps> = ({isDesktop, resultPerPage, numberOfResults, currentPageNumber, searchQuery})  => {
    const numberOfResultsString = findNumberOfResultString(numberOfResults, resultPerPage, currentPageNumber, searchQuery);

    if(numberOfResults === 0) {
        return <div></div>
    }

    return <div data-size={isDesktop ? 'md' : 'sm'} className={isDesktop ? "numresults-text" : "resultNumberMobile-notinuse"} role="status">{numberOfResultsString}</div>
}


function findNumberOfResultString(numberOfResults: number, resultsPerPage: number, currentPageNumber: number, searchQuery?: string) {
    const queryText = searchQuery ? ` for "${searchQuery}"` : '';
    if (numberOfResults === 1) {
        return `Viser 1 treff${queryText}`;
    } else if (numberOfResults < resultsPerPage) {
        return `Viser 1-${numberOfResults} av ${numberOfResults} treff${queryText}`;
    } else {
        let topResultNumber = resultsPerPage * currentPageNumber;
        const bottomResultNumber = topResultNumber - (resultsPerPage - 1);
        if(numberOfResults < topResultNumber){
            topResultNumber = numberOfResults;
        }
        return `Viser ${bottomResultNumber}-${topResultNumber} av ${numberOfResults} treff${queryText}`;
    }
}
